import { KYMW1102SearchResultModel } from '../vo/kymw1102-search-result.model';
import { PlessResponder } from '../../../../shared/http/pless-responder.service';
import { KYMW1102Model } from '../kymw1102.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 供給計画取得クラス
 *
 * @export CalcSupplyPlanService
 * @class CalcSupplyPlanService
 * @extends {PlessResponder}
 */
@Injectable()
export class CalcSupplyPlanService extends PlessJsonResponderSub<any> {

  // VO
  private vo: KYMW1102SearchResultModel = new KYMW1102SearchResultModel;
  // 処理に使用するModel
  private model: KYMW1102Model;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof CalcSupplyPlanService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        SupplyTaxWithoutStd: this.vo.supplyPrice,
        PointPlan: this.vo.pointPlan
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model 処理に使用するモデル
   * @param vo vo
   * @param successFunc 成功時に実行される処理
   * @memberof CalcSupplyPlanService
   */
  execute(model: KYMW1102Model, vo: KYMW1102SearchResultModel, successFunc: Function = null): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;

    // 供給計画初期化(画面再表示不具合対応)
    this.model.supplyPlan = '千円';

    this.send('getSupplyPlan', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof CalcSupplyPlanService
   */
  success(data: any): void {
    this.model.setCalcSupplyPlan(data);

    this.model.kymw1102Component.updateDgridEnable(true);
    this.model.kymw1102Component.txt_year.nativeElement.focus();
    // レスポンスのファイルパスをマネージに保存
    if (this.successFunc !== null) {
      this.successFunc(data);
    }
  }
}
